import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  ReactFlow,
  Background,
  Controls,
  MiniMap,
  ReactFlowProvider,
  addEdge,
  useNodesState,
  useEdgesState,
  Handle,
  Position,
  Panel
} from '@xyflow/react';
import { Modal, Form, Dropdown, Menu, Button, message, Input, Select } from 'antd';
import '@xyflow/react/dist/style.css';
import { Play, Mail, HelpCircle, StopCircle, Plus, X, Delete, ArrowRightLeft, Repeat, FileSearch, SquarePen, FilePlus, Trash2, Equal, FastForward } from "lucide-react";
import CreateNodeFlowDrawer from './CreateNodeFlowDrawer';
import TopUtilityBar from "./TopUtilityBar";
import FlowDetailsModal from "./FlowDetailsModal";
import { useLocation } from 'react-router-dom';
import StartNodeDrawer from "./StartNodeDrawer";
import GetNodeFlowDrawer from "./GetNodeFlowDrawer";
import UpdateNodeFlowDrawer from "./UpdateNodeFlowDrawer";
import AssignmentNodeFlowDrawer from "./AssignmentNodeFlowDrawer";
// import DeleteNodeFlowDrawer from "./DeleteNodeFlowDrawer";
// import DecisionNodeFlowDrawer from "./DecisionNodeFlowDrawer";

// Utility to generate unique IDs
let id = 2;
const getId = () => `${id++}`;

const nodeOptions = [
  { label: "Insert", type: "insert", icon: FilePlus, bgColor: "#007bff" },   // light orange
  { label: "Update", type: "update", icon: SquarePen, bgColor: "#007bff" },
  { label: "Get", type: "get_query", icon: FileSearch, bgColor: "#007bff" },
  { label: "Delete", type: "delete", icon: Trash2, bgColor: "#dc3545" }, // light blue
  { label: "Decision", type: "decision", icon: ArrowRightLeft, bgColor: "#90caf9" }, // light blue
  { label: "Loop", type: "loop", icon: Repeat, bgColor: "#90caf9" }, // light blue
  { label: "Assignment", type: "assignment", icon: Equal, bgColor: "#007bff" }, // light blue
];

const { Option } = Select;

//previous Icon Node
// const IconNode = ({ icon: Icon, label, bgColor, data, selected, handleTop = true, handleBottom = true }) => {
//   const [showDropdown, setShowDropdown] = useState(false);

//   return (
//     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
//       <div
//         style={{
//           width: 40,
//           height: 40,
//           borderRadius: 10,
//           backgroundColor: bgColor,
//           boxShadow: selected ? `0 0 10px 3px ${bgColor}` : 'none',
//           display: "flex",
//           opacity: "50%",
//           justifyContent: "center",
//           alignItems: "center",
//           position: "relative",
//         }}
//       >
//         {handleTop && (
//           <Handle
//             type="target"
//             position={Position.Top}
//             style={{ background: "#666", top: -8 }}
//           />
//         )}
//         <Icon size={20} color="white" />
//         {handleBottom && (
//           <Handle
//             type="source"
//             position={Position.Bottom}
//             style={{ background: "#666", bottom: -8 }}
//           />
//         )}
//       </div>
//       <span style={{ marginTop: 6, fontSize: 12, fontWeight: 500 }}>{label}</span>

//       {/* <button
//         style={{ marginTop: 6, background: "#e0e0e0", border: "none", borderRadius: 4, cursor: "pointer", padding: "2px 6px" }}
//         onClick={(e) => {
//           e.stopPropagation();
//           setShowDropdown((prev) => !prev);
//         }}
//       >
//         <Plus size={14} />
//       </button> */}
//       <button
//         style={{
//           marginTop: 6,
//           background: "#e0e0e0",
//           border: "none",
//           borderRadius: 4,
//           cursor: "pointer",
//           padding: "2px 6px"
//         }}
//         onClick={(e) => {
//           e.stopPropagation();
//           setShowDropdown((prev) => !prev);
//         }}
//       >
//         {showDropdown ? <X size={14} /> : <Plus size={14} />}
//       </button>
//       {showDropdown && (
//         <div
//           style={{
//             position: "absolute",
//             top: 90,
//             background: "#fff",
//             border: "1px solid #ccc",
//             borderRadius: 4,
//             padding: 4,
//             zIndex: 9999,
//           }}
//         >
//           {nodeOptions.map((opt) => {
//             const Icon = opt.icon;
//             return (
//               <div
//                 key={opt.label}
//                 style={{ padding: "4px 8px", cursor: "pointer", display: 'flex', alignItems: 'center', gap: 6, boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)' }}
//                 onClick={() => {
//                   data.onAddNode(opt.type, data.nodeId);
//                   setShowDropdown(false);
//                 }}
//               >
//                 {Icon && <Icon size={16} />}
//                 {opt.label}
//               </div>
//             );
//           })}

//         </div>
//       )}
//     </div>
//   );
// };

const IconNode = ({ icon: Icon, label, bgColor, data, selected, handleTop = true, handleBottom = true }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: 10,
          backgroundColor: bgColor,
          boxShadow: selected ? `0 0 10px 3px ${bgColor}` : "none",
          display: "flex",
          opacity: "50%",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        {handleTop && (
          <Handle
            type="target"
            position={Position.Top}
            style={{ background: "#666", top: -8 }}
          />
        )}
        <Icon size={20} color="white" />
        {handleBottom && (
          <Handle
            type="source"
            position={Position.Bottom}
            style={{ background: "#666", bottom: -8 }}
          />
        )}
      </div>
      <span style={{ marginTop: 6, fontSize: 12, fontWeight: 500 }}>{label}</span>

      <button
        style={{
          marginTop: 6,
          background: "#e0e0e0",
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
          padding: "2px 6px",
        }}
        onClick={(e) => {
          e.stopPropagation();
          setShowDropdown((prev) => !prev);
        }}
      >
        {showDropdown ? <X size={14} /> : <Plus size={14} />}
      </button>

      {showDropdown && (
        <div
          style={{
            position: "absolute",
            top: 90,
            width: 180,
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: 4,
            padding: 4,
            zIndex: 9999,
          }}
          onClick={(e) => e.stopPropagation()} // prevent closing on clicking inside
        >
          <Select
            showSearch
            placeholder="Select a node type"
            optionFilterProp="label"
            onChange={(value) => {
              const selectedOpt = nodeOptions.find((opt) => opt.type === value);
              if (selectedOpt) {
                data.onAddNode(selectedOpt.type, data.nodeId);
              }
              setShowDropdown(false);
            }}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            style={{ width: "100%" }}
            autoFocus
            open
            onDropdownVisibleChange={(open) => {
              if (!open) setShowDropdown(false);
            }}
          >
            {nodeOptions.map((opt) => (
              <Option
                key={opt.type}
                value={opt.type}
                label={opt.label}
                style={{ display: "flex", alignItems: "center", gap: 6 }}
              >
                {opt.icon && <opt.icon size={16} />}
                {opt.label}
              </Option>
            ))}
          </Select>

        </div>
      )}
    </div>
  );
};

// const DiamondDecisionNode = ({ data, selected }) => {
//   const [showDropdown, setShowDropdown] = useState(false);

//   return (
//     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
//       <div style={{ width: 60, height: 60, position: "relative" }}>
//         <svg width="60" height="60" viewBox="0 0 60 60">
//           <defs>
//             <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
//               <feDropShadow dx="0" dy="0" stdDeviation="5" flood-color="darkorange" />
//             </filter>
//           </defs>

//           <polygon
//             points="30,0 60,30 30,60 0,30"
//             fill="orange"
//             stroke={selected ? "none" : "darkorange"}
//             strokeWidth={2}
//             filter={selected ? "url(#glow)" : "none"}
//             icon={ArrowRightLeft}
//           />
//         </svg>

//         <Handle
//           type="target"
//           position={Position.Top}
//           style={{ background: "darkorange", top: -8, left: "50%", transform: "translateX(-50%)" }}
//         />
//         {/* Icon centered inside diamond */}
//         <ArrowRightLeft
//           size={20}
//           color="white"
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             pointerEvents: "none"
//           }}
//         />
//         {/* <HelpCircle
//           size={20}
//           color="white"
//           style={{ position: "absolute", top: "20px", left: "20px" }}
//         /> */}
//         <Handle
//           type="source"
//           position={Position.Bottom}
//           style={{ background: "darkorange", bottom: -8, left: "50%", transform: "translateX(-50%)" }}
//         />
//       </div>
//       <span style={{ marginTop: 6, fontSize: 12, fontWeight: 500 }}>{data.label}</span>

//       <button
//         style={{ marginTop: 6, background: "#e0e0e0", border: "none", borderRadius: 4, cursor: "pointer", padding: "2px 6px" }}
//         onClick={(e) => {
//           e.stopPropagation();
//           setShowDropdown((prev) => !prev);
//         }}
//       >
//         <Plus size={14} />
//       </button>

//       {showDropdown && (
//         <div
//           style={{
//             position: "absolute",
//             top: 110,
//             background: "#fff",
//             border: "1px solid #ccc",
//             borderRadius: 4,
//             padding: 4,
//             zIndex: 9999,

//           }}
//         >
//           {nodeOptions.map((opt) => {
//             const Icon = opt.icon;
//             return (
//               <div
//                 key={opt.label}
//                 style={{ padding: "4px 8px", cursor: "pointer", display: 'flex', alignItems: 'center', gap: 6, boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)' }}
//                 onClick={() => {
//                   data.onAddNode(opt.type, data.nodeId);
//                   setShowDropdown(false);
//                 }}
//               >
//                 {Icon && <Icon size={16} />}
//                 {opt.label}
//               </div>
//             );
//           })}

//         </div>
//       )}
//     </div>
//   );
// };


const DiamondDecisionNode = ({ data, selected }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
      <div style={{ width: 60, height: 60, position: "relative" }}>
        <svg width="60" height="60" viewBox="0 0 60 60">
          <defs>
            <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
              <feDropShadow dx="0" dy="0" stdDeviation="5" floodColor="darkorange" />
            </filter>
          </defs>

          <polygon
            points="30,0 60,30 30,60 0,30"
            fill="orange"
            stroke={selected ? "none" : "darkorange"}
            strokeWidth={2}
            filter={selected ? "url(#glow)" : "none"}
          />
        </svg>

        <Handle
          type="target"
          position={Position.Top}
          style={{ background: "darkorange", top: -8, left: "50%", transform: "translateX(-50%)" }}
        />
        <ArrowRightLeft
          size={20}
          color="white"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none"
          }}
        />
        <Handle
          type="source"
          position={Position.Bottom}
          style={{ background: "darkorange", bottom: -8, left: "50%", transform: "translateX(-50%)" }}
        />
      </div>

      <span style={{ marginTop: 6, fontSize: 12, fontWeight: 500 }}>{data.label}</span>

      <button
        style={{
          marginTop: 6,
          background: "#e0e0e0",
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
          padding: "2px 6px",
        }}
        onClick={(e) => {
          e.stopPropagation();
          setShowDropdown((prev) => !prev);
        }}
      >
        {showDropdown ? <X size={14} /> : <Plus size={14} />}
      </button>

      {showDropdown && (
        <div
          style={{
            position: "absolute",
            top: 110,
            width: 180,
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: 4,
            padding: 4,
            zIndex: 9999,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Select
            showSearch
            placeholder="Select a node type"
            optionFilterProp="label"
            onChange={(value) => {
              const selectedOpt = nodeOptions.find((opt) => opt.type === value);
              if (selectedOpt) {
                data.onAddNode(selectedOpt.type, data.nodeId);
              }
              setShowDropdown(false);
            }}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            style={{ width: "100%" }}
            autoFocus
            open
            onDropdownVisibleChange={(open) => {
              if (!open) setShowDropdown(false);
            }}
          >
            {nodeOptions.map((opt) => (
              <Option
                key={opt.type}
                value={opt.type}
                label={opt.label}
                style={{ display: "flex", alignItems: "center", gap: 6 }}
              >
                {opt.icon && <opt.icon size={16} />}
                {opt.label}
              </Option>
            ))}
          </Select>
        </div>
      )}
    </div>
  );
};

const nodeTypes = {
  start: (props) => <IconNode {...props} icon={Play} label="Start" bgColor="#28a745" handleTop={false} selected={props.selected} {...props} />,
  insert: (props) => <IconNode {...props} icon={FilePlus} label="Insert Node" bgColor="#007bff" selected={props.selected} {...props} />,
  get_query: (props) => <IconNode {...props} icon={FileSearch} label="Get" bgColor="#007bff" selected={props.selected} {...props} />,
  update: (props) => <IconNode {...props} icon={SquarePen} label="Update" bgColor="#007bff" selected={props.selected} {...props} />,
  delete: (props) => <IconNode {...props} icon={Trash2} label="Delete" bgColor="#dc3545" selected={props.selected} {...props} />,
  loop: (props) => <IconNode {...props} icon={Repeat} label="Loop" bgColor="#007bff" selected={props.selected} {...props} />,
  assignment: (props) => <IconNode {...props} icon={Equal} label="Assignment" bgColor="darkorange" selected={props.selected} {...props} />,
  decision: props => (
    <DiamondDecisionNode data={props.data} selected={props.data.selected} {...props} />
  ),
  endNode: (props) => <IconNode {...props} icon={StopCircle} label="End" bgColor="#dc3545" handleBottom={false} selected={props.selected} {...props} />,
};

const initialNodes = [
  { id: "1", type: "start", position: { x: 150, y: 0 }, data: {} },
  // { id: "2", type: "insertNode", position: { x: 100, y: 150 }, data: {} },
  // { id: "3", type: "decisionNode", position: { x: 350, y: 150 }, data: { label: "Is Approved?" } },
  // { id: "4", type: "endNode", position: { x: 250, y: 300 }, data: {} },
];

// Default edge styles
const edgeStyleLight = {
  stroke: "#ccc",    // light gray
  strokeWidth: 3,
  // a bit bold
};

const edgeStyleDark = {
  stroke: "#333",    // dark gray
  strokeWidth: 3,    // a bit bold
};

// const initialEdges = [
//   // { id: "e1-2", source: "1", target: "2", animated: true, style: edgeStyleLight },
//   // { id: "e2-3", source: "2", target: "3", animated: true, style: edgeStyleLight },
//   // { id: "e3-4", source: "3", target: "4", animated: true, style: edgeStyleLight },
// ];

function FlowScreen() {
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [selectedEdgeIds, setSelectedEdgeIds] = useState([]);
  const [createRecordDrawerVisible, setCreateRecordDrawerVisible] = useState(false);
  const [selectedNode, setSelectedNode] = useState(false);
  const [nodeData, setNodeData] = useState([]);
  const [startNodeDrawer, setStartNodeDrawer] = useState(false);
  const [startData, setStartData] = useState({});
  const location = useLocation();
  const formData = location.state?.formData;
  const object = location.state?.object;
  const selectedFlowData = location?.state?.selectedFlowData;
  const [nodes, setNodes, onNodesChange] = useNodesState(selectedFlowData ? [] : initialNodes);
  // const isEditingFlow = location?.state?.isEditingFlow;
  const [isModalForFlowDetailsVisible, setIsModalForFlowDetailsVisible] = useState(false);
  const [createRecordData, setCreateRecordData] = useState({}); // Store Create Records data here
  const [getRecordData, setGetRecordData] = useState({}); // Store Get Records data here
  const [updateRecordData, setUpdateRecordData] = useState({}); // Store Update Records data here
  const [deleteRecordData, setDeleteRecordData] = useState({}); // Store Delete Records data here
  const [selectedNodeIds, setSelectedNodeIds] = useState([]);
  const [highlightedNode, setHighlightedNode] = useState(null);
  const [singleCreateRecordDataInEditMode, setSingleCreateRecordDataInEditMode] = useState([]);
  const [singleGetRecordDataInEditMode, setSingleGetRecordDataInEditMode] = useState([]);
  const [singleUpdateRecordDataInEditMode, setSingleUpdateRecordDataInEditMode] = useState([]);
  const [showGetNodeDrawer, setShowGetNodeDrawer] = useState(false);
  const [showUpdateNodeDrawer, setShowUpdateNodeDrawer] = useState(false);
  const [assignmentNodeData, setAssignmentNodeData] = useState({});
  const [assignmentNodeDrawer, setAssignmentNodeDrawer] = useState(false);
  const [singleAssignmentRecordDataInEditMode, setSingleAssignmentRecordDataInEditMode] = useState({});
  const [singleDeleteRecordDataInEditMode, setSingleDeleteRecordDataInEditMode] = useState({});
  const [apiNameMap, setApiNameMap] = useState(new Map());
  const [deleteNodeDrawer, setDeleteNodeDrawer] = useState(false);
  const [singleDecisionRecordDataInEditMode,setSingleDecisionRecordDataInEditMode] = useState({});
  const [decisionNodeData,setDecisionNodeData] = useState({});
  const [decisionNodeDrawer,setDecisionNodeDrawer] = useState(false);

  const handleAddNode = useCallback(
    (type, parentId) => {
      console.log('typee:', type);
      console.log('parentID:', parentId);

      const parentNode = nodes.find((n) => n.id === parentId);
      if (!parentNode) return;
      console.log('parent node:',parentNode);
      const newNodeId = getId();
      const newNode = {
        id: newNodeId,
        type,
        // draggable:false,
        position: {
          x:  parentNode.position.x,
          y:  parentNode.position.y + 150,
        },
        data: {
          label: type === "decision" ? "Decision?" : undefined,
          nodeId: newNodeId,
          nodeName: '',
          onAddNode: handleAddNode,
        },
      };

      const newEdge = {
        id: `e${parentId}-${newNodeId}`,
        source: parentId,
        target: newNodeId,
        animated: true,
        style: edgeStyleLight,
      };

      setNodes((nds) =>
        [...nds, newNode].map((node) =>
          node.id === parentId
            ? { ...node, data: { ...node.data, onAddNode: handleAddNode, nodeId: parentId } }
            : node
        )
      );
      setEdges((eds) => [...eds, newEdge]);
    },
    [nodes]
  );

  const enrichedNodes = nodes.map((node) => ({
    ...node,
    data: {
      ...node.data,
      onAddNode: handleAddNode,
      nodeId: node.id,
    },
  }));

  // When edges or selected edges change, update edge styles accordingly
  const styledEdges = edges.map((edge) => ({
    ...edge,
    style: selectedEdgeIds.includes(edge.id) ? edgeStyleDark : edgeStyleLight,
  }));

  const setttingFilters = (filters) => {
    const filterObj = filters.reduce((acc, filter, index) => {
      if (filter.field) {
        acc[index + 1] = {
          field: filter.field,
          value: filter.value
        };
      }
      return acc;
    }, {});

    return filterObj;
  }


  const handleNodeDoubleClick = (node, props) => {
    console.log('selected node', node);
    console.log('selected node', props);
    // Check if any drawer is already open
    if (createRecordDrawerVisible || startNodeDrawer || showGetNodeDrawer || showUpdateNodeDrawer || assignmentNodeDrawer || deleteNodeDrawer) {
      // Show error message
      message.error("Please Save/Close Current Open Drawer");
      return;
    }

    if (props.type === 'insert') {
      setSelectedNode(props);
      setSingleCreateRecordDataInEditMode(createRecordData[props.id]);
      setCreateRecordDrawerVisible(true);
    }
    else if (props.type === 'start') {
      setSelectedNode(props);
      setStartNodeDrawer(true);
    }
    else if (props.type === 'get_query') {
      setSelectedNode(props);
      setSingleGetRecordDataInEditMode(getRecordData[props.id]);
      console.log('getRecordData', getRecordData);
      console.log('getRecordData[props.id::::', getRecordData[props.id]);
      setShowGetNodeDrawer(true);
    }
    else if (props.type === 'update') {
      setSelectedNode(props);
      console.log("updateRecordData:::", updateRecordData);
      setSingleUpdateRecordDataInEditMode(updateRecordData[props.id]);
      setShowUpdateNodeDrawer(true);
    }
    // else if (props.type === 'delete') {
    //   setSelectedNode(props);
    //   console.log("deleterecord data:::", deleteRecordData);
    //   setSingleDeleteRecordDataInEditMode(deleteRecordData[props.id]);
    //   setDeleteNodeDrawer(true);
    // }
    else if (props.type === 'assignment') {
      setSelectedNode(props);
      console.log("assignmentNodeData", assignmentNodeData);
      console.log("assignmentNodeData[props.id]", assignmentNodeData[props.id]);
      setSingleAssignmentRecordDataInEditMode(assignmentNodeData[props.id]);

      setAssignmentNodeDrawer(true);
    }
    // else if (props.type === 'decision') {
    //   setSelectedNode(props);
    //   console.log("decisionNodeData", decisionNodeData);
    //   setSingleDecisionRecordDataInEditMode(decisionNodeData[props.id]);
    //   setDecisionNodeDrawer(true);
    // }
  }
  // Track selected edges
  const onSelectionChange = ({ edges: selected }) => {
    setSelectedNodeIds(nodes ? nodes.map((node) => node.id) : []);
    setSelectedEdgeIds(selected ? selected.map((e) => e.id) : []);
  };

  // Handle delete key to remove selected edges
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Delete" || e.key === "Backspace") {
        setEdges((eds) => eds.filter((edge) => !selectedEdgeIds.includes(edge.id)));
        setSelectedEdgeIds([]);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedEdgeIds, setEdges]);

  useEffect(() => {
    console.log('selected Flow Data is here in useeffect', selectedFlowData);
    console.log('selected Nodes Data is here in useeffect', nodes);

    if (selectedFlowData) {
      const { nodes: newNodes, edges: newEdges } = processFlowData(selectedFlowData);
      console.log('nodes after processing', newNodes);
      // Update state for nodes and edges
      // setNodes((prevNodes) => [...prevNodes, ...newNodes]); // Append new nodes
      // setEdges((prevEdges) => [...prevEdges, ...newEdges]); // Append new edges
      // Not Appending as it adds twice since it is running in strict mode
      setNodes(newNodes);
      setEdges(newEdges);
      console.log('nodes after processing after setting', nodes);

    }
  }, [selectedFlowData])


  useEffect(() => {
    console.log('inside the useeffect for nodess array::', nodes);
    console.log('create data in the useeffect::', createRecordData);
  }, [nodes])


  const processFlowData = (flowData) => {
    if (!flowData || !flowData.mt_nodes || !flowData.mt_transitions) {
      return { nodes: [], edges: [] };
    }

    const createRecordsData = {};
    const getRecordsData = {};
    const updateRecordData = {};
    const deleteRecordsData = {};
    const decisionRecordsData = {};
    const assignmentRecordData = {};
    // Create a lookup map: node.name => _id
    const nodeLookup = {};
    flowData.mt_nodes.forEach((node) => {
      if (node.name) {
        nodeLookup[node.name] = node._id;
      }
    });
    console.log('nodeLookup', nodeLookup);
    // Build a fresh Map of nodeId -> apiName from loaded nodes
    const newApiNameMap = new Map();
    flowData.mt_nodes.forEach(({ _id, name }) => {
      if (name) {
        newApiNameMap.set(_id, name);
      }
    });
    console.log('newApiNameMap', newApiNameMap);

    // Update the React state with this fresh Map
    setApiNameMap(newApiNameMap);


    const nodes = flowData.mt_nodes.map((node) => {
      const { _id, coordinates, parameters, type, name, label } = node;
      switch (type) {
        case "insert":
          createRecordsData[_id] = node;
          break;
        case "get_query":
          getRecordsData[_id] = node;
          break;
        case "update":
          updateRecordData[_id] = node;
          break;
        case "delete":
          deleteRecordsData[_id] = node;
          break;
        case "decision":
          decisionRecordsData[_id] = node;
          break;
        case "assignment":
          assignmentRecordData[_id] = node;
          break;
        default:
          break;
      }

      return {
        id: _id,
        name: name,
        apiName: name,
        parameters,
        type,
        position: { x: coordinates?.[0] || 200, y: coordinates?.[1] || 150 },
        draggable: true,
        data: {
          label: label,
          nodeId: _id,
          nodeName: name,
          onAddNode: handleAddNode,
        },
      };
    });
    console.log('api name set::', apiNameMap);
    nodes.unshift({
      id: "start",
      position: { x: 150, y: 0 },
      data: {},
      type: "start",
    });

    const edges = flowData.mt_transitions
      .map((transition) => {
        const { _id, from_node, to_node } = transition;

        // const fromNodeId = from_node === "1" ? "start" : nodeLookup[from_node];
        const fromNodeId = (from_node === "start" || from_node === "1") ? "start" : nodeLookup[from_node];

        const toNodeId = nodeLookup[to_node];

        if (!fromNodeId || !toNodeId) {
          console.error(`Invalid transition: from_node=${from_node}, to_node=${to_node}`);
          return null;
        }

        return {
          id: _id,
          source: fromNodeId,
          target: toNodeId,
          animated: true,
          style: edgeStyleLight,
        };
      })
      .filter(Boolean);

    setCreateRecordData((prev) => ({ ...prev, ...createRecordsData }));
    console.log('createRecordsData::', createRecordsData);

    setGetRecordData((prev) => ({ ...prev, ...getRecordsData }));
    console.log('getRecordData::', getRecordData);

    setUpdateRecordData((prev) => ({ ...prev, ...updateRecordData }));
    console.log('updateRecordData::', updateRecordData);

    setDeleteRecordData((prev) => ({ ...prev, ...deleteRecordData }));
    console.log('deleteRecordData::', deleteRecordData);

    setAssignmentNodeData((prev) => ({ ...prev, ...assignmentRecordData }))
    console.log('assignmentNodeData::', assignmentRecordData);

    setStartData(mapSelectedFlowDataToStartNode(flowData));

    setDecisionNodeData((prev) => ({ ...prev, ...decisionRecordsData }));

    return { nodes, edges };
  };

  const mapSelectedFlowDataToStartNode = (flowData) => {
    return {
      object: flowData?.model,                    // maps model to object
      trigger: flowData?.event.replace('after_', ''), // 'after_create' → 'create'
      conditions: [],                            // your example shows empty, but can extract if present
      logic: '',                                 // default unless stored in the flow
      runAsync: flowData?.runAsync || false,
      optimization: flowData?.event || 'before_create'                    // or extract from flowData if it exists
    };
  };
  const getNodeParameters = (node, fromFlowBody) => {
    switch (node.type) {
      case "decision":
        return {
          model: node?.selectedObject || '',
          conditions: node?.outcomes?.map((outcome, index) => ({
            logic_string: outcome?.logic_string || "1",
            name: outcome?.label, // Use outcome API name for transition
            apiname: outcome?.apiName,
            picklist: outcome?.picklist,
            conditions: setttingFilters(outcome?.filters),
          })) || []
        };

      case "Create Records":
        if (fromFlowBody) {
          return {
            model: node?.parameters?.model || "", // Use model if available
            fields: Object.entries(node?.parameters?.fields || {}).reduce((acc, [key, value]) => {
              acc[key] = value; // Convert object into the expected format
              return acc;
            }, {}) // Ensure a valid fallback
          }
        }
        return {
          model: node?.objectName || "", // Use selected object
          fields: node?.fields?.reduce((acc, fieldObj) => {
            acc[fieldObj.field] = fieldObj.value; // Convert array to object
            return acc;
          }, {}) || {} // Ensure a valid fallback
        };
      case "Update Records":
        return {
          model: node?.selectedObject || "",  // Default to "DefaultModel" if no selectedObject is provided
          logic_string: node?.logic || "1",  // Default to "1" if no logic is provided

          // Transform the filterObj to conditions object, assuming filterObj follows the format you provided
          conditions: Object.keys(node?.filterObj || {}).reduce((acc, key) => {
            const condition = node?.filterObj[key];
            acc[key] = {
              field: condition.field,
              value: condition.value, // Adjust as needed for condition values
            };
            return acc;
          }, {}),

          // Ensure fieldValues are structured as an object for updates
          updates: node?.fieldValues || {},
        };
      case "Delete Records":
        if (fromFlowBody) {
          return {
            model: node?.parameters?.model || "",  // Default to empty string
            logic_string: node?.parameters?.logic_string || "1",   // Default to "1"

            // Convert `conditions` array into expected `filterObj` format
            conditions: node?.parameters?.conditions?.length > 0
              ? node?.parameters?.conditions.reduce((acc, condition, index) => {
                acc[index + 1] = {
                  field: condition.field || "",
                  value: condition.value || "",
                };
                return acc;
              }, {})
              : node?.parameters?.filterObj || {},
          };
        }
        return {
          model: node?.selectedObject || "",  // Default to empty string
          logic_string: node?.logic || "1",   // Default to "1"

          // Convert filterObj object to an array of condition objects
          conditions: node?.filterObj || {}
        };
      case "Get Records":
        if (fromFlowBody) {
          return {
            model: node?.parameters?.model || "",  // Default to empty string
            logic_string: node?.parameters?.logic_string || "1",   // Default to "1"

            // Convert `conditions` array into expected `filterObj` format
            conditions: node?.parameters?.conditions?.length > 0
              ? node?.parameters?.conditions.reduce((acc, condition, index) => {
                acc[index + 1] = {
                  field: condition.field || "",
                  value: condition.value || "",
                };
                return acc;
              }, {})
              : node?.parameters?.filterObj || {},
          };
        }
        return {
          model: node?.selectedObject || "",  // Default to empty string
          logic_string: node?.logic || "1",   // Default to "1"

          // Convert filterObj object to an array of condition objects
          conditions: Object.values(node?.filterObj || {}).map(filter => {
            const operator = Object.keys(filter.value || {})[0]; // Extract operator (e.g., "contains")
            const actualValue = filter.value[operator] || "";  // Extract actual value (e.g., "asds")

            return {
              field: filter.field || "",
              value: { [operator]: actualValue || "" }
            };
          }),
        };

      case "Loop":
        return {
          model: "Sticker", // Example model
          fields: { Name: "$Name" }, // Example field
        };
      default:
        return {};
    }
  };


  const handleCreateRecordSave = (nodeId, createData) => {

    console.log('node id::', nodeId);
    console.log('create dataa::', createData);
    console.log('all nodes bfore upd:', nodes);
    const isDuplicate = Array.from(apiNameMap.entries()).some(
      ([id, name]) => id !== nodeId && name === createData.apiName
    );

    if (isDuplicate) {
      message.error('ApiName already used!');
      return;
    }

    setApiNameMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(nodeId, createData.apiName);
      return newMap;
    });

    console.log('apiNameMap updated:', apiNameMap);

    setCreateRecordDrawerVisible(false);

    // const allNodesData = getAllNodesData(getRecordsData, updateRecordData, deleteRecordData, createRecordData);

    // if (!isApiNameUnique(createData.apiName, nodeId, allNodesData)) {
    //   alert(`API name "${createData.apiName}" is already taken. Please choose a different name.`);
    //   return;
    // }

    // const parameters = getNodeParameters(createData, false); // Generate parameters for the node
    const parameters = createData.parameters; // Get parameters for the node

    // Update the nodes state
    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === nodeId
          ? {
            ...node,
            data: {
              ...node.data,
              nodeName: createData.apiName,
              label: createData.name
            },
            selectedObject: createData.selectedObject,
            parameters,
            description: createData.description,
            apiname: createData.apiName,
            name: createData.name,
          }
          : node
      )
    );

    console.log('all nodes::', nodes);
    // Prepare and save create record data separately
    const createNode = {
      id: createData.id,
      name: createData.name,
      type: createData.type,
      description: createData.description,
      apiName: createData.apiName,
      parameters: parameters,
    };

    setCreateRecordData((prevData) => ({
      ...prevData,
      [nodeId]: createNode,
      data: {
        name: createData.apiName,
        label: createData.name
      }
    }));

    console.log(`Create Records Data for node ${nodeId}:`, createData);
  };

  const handleAssignmentRecordSave = (nodeId, assignData) => {

    console.log('node id::', nodeId);
    console.log('assign dataa::', assignData);
    console.log('all nodes bfore upd:', nodes);
    const isDuplicate = Array.from(apiNameMap.entries()).some(
      ([id, name]) => id !== nodeId && name === assignData.apiName
    );

    if (isDuplicate) {
      message.error('ApiName already used!');
      return;
    }

    setApiNameMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(nodeId, assignData.apiName);
      return newMap;
    });

    console.log('apiNameMap updated:', apiNameMap);

    setAssignmentNodeDrawer(false);
    // const allNodesData = getAllNodesData(getRecordsData, updateRecordData, deleteRecordData, createRecordData);

    // if (!isApiNameUnique(createData.apiName, nodeId, allNodesData)) {
    //   alert(`API name "${createData.apiName}" is already taken. Please choose a different name.`);
    //   return;
    // }

    // const parameters = getNodeParameters(createData, false); // Generate parameters for the node
    const parameters = assignData.parameters; // Get parameters for the node

    // Update the nodes state
    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === nodeId
          ? {
            ...node,
            data: {
              ...node.data,
              nodeName: assignData.apiName,
              label: assignData.name
            },
            selectedObject: assignData.selectedObject,
            parameters,
            description: assignData.description,
            apiname: assignData.apiName,
            name: assignData.name,
          }
          : node
      )
    );

    console.log('all nodes::', nodes);
    // Prepare and save create record data separately
    const assignNode = {
      id: assignData.id,
      name: assignData.name,
      type: assignData.type,
      description: assignData.description,
      apiName: assignData.apiName,
      parameters: parameters,
      data: {
        name: assignData.apiName,
        label: assignData.name
      }
    };

    setAssignmentNodeData((prevData) => ({
      ...prevData,
      [nodeId]: assignNode,

    }));

    console.log(`Create Records Data for node ${nodeId}:`, assignNode);
  };

  const handleGetRecordSave = (nodeId, getData) => {

    console.log('node id::', nodeId);
    console.log('getData ::', getData);
    console.log('all nodes bfore upd:', nodes);
    const isDuplicate = Array.from(apiNameMap.entries()).some(
      ([id, name]) => id !== nodeId && name === getData.apiName
    );

    if (isDuplicate) {
      message.error('ApiName already used!');
      return;
    }


    setApiNameMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(nodeId, getData.apiName);
      return newMap;
    });

    console.log('apiNameMap updated:', apiNameMap);

    setShowGetNodeDrawer(false);
    // const allNodesData = getAllNodesData(getRecordsData, updateRecordData, deleteRecordData, createRecordData);

    // if (!isApiNameUnique(createData.apiName, nodeId, allNodesData)) {
    //   alert(`API name "${createData.apiName}" is already taken. Please choose a different name.`);
    //   return;
    // }

    // // const parameters = getNodeParameters(createData, false); // Generate parameters for the node
    const parameters = getData.parameters; // Get parameters for the node

    // Update the nodes state
    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === nodeId
          ? {
            ...node,
            data: {
              ...node.data,
              nodeName: getData.apiName,
              label: getData.name
            },
            selectedObject: getData.selectedObject,
            parameters,
            description: getData.description,
            apiname: getData.apiName,
            name: getData.name,
          }
          : node
      )
    );

    console.log('all nodes::', nodes);
    // Prepare and save create record data separately
    const getNode = {
      id: getData.id,
      name: getData.name,
      type: getData.type,
      description: getData.description,
      apiName: getData.apiName,
      parameters: parameters,
    };

    setGetRecordData((prevData) => ({
      ...prevData,
      [nodeId]: getNode,
      data: {
        name: getData.apiName,
        label: getData.name
      }
    }));

    console.log(`Create Records Data for node ${nodeId}:`, getNode);
  };

  const handleUpdateRecordSave = (nodeId, updateData) => {

    console.log('node id::', nodeId);
    console.log('updateData ::', updateData);
    console.log('all nodes bfore upd:', nodes);
    const isDuplicate = Array.from(apiNameMap.entries()).some(
      ([id, name]) => id !== nodeId && name === updateData.apiName
    );

    if (isDuplicate) {
      message.error('ApiName already used!');
      return;
    }

    setApiNameMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(nodeId, updateData.apiName);
      return newMap;
    });

    console.log('apiNameMap updated:', apiNameMap);

    setShowUpdateNodeDrawer(false);

    // const allNodesData = getAllNodesData(getRecordsData, updateRecordData, deleteRecordData, createRecordData);

    // if (!isApiNameUnique(createData.apiName, nodeId, allNodesData)) {
    //   alert(`API name "${createData.apiName}" is already taken. Please choose a different name.`);
    //   return;
    // }

    // const parameters = getNodeParameters(createData, false); // Generate parameters for the node
    const parameters = updateData.parameters; // Get parameters for the node

    // Update the nodes state
    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === nodeId
          ? {
            ...node,
            data: {
              ...node.data,
              nodeName: updateData.apiName,
              label: updateData.name
            },
            selectedObject: updateData.selectedObject,
            parameters,
            description: updateData.description,
            apiname: updateData.apiName,
            name: updateData.name,
          }
          : node
      )
    );

    console.log('all nodes::', nodes);
    // Prepare and save create record data separately
    const updateNode = {
      id: updateData.id,
      name: updateData.name,
      type: updateData.type,
      description: updateData.description,
      apiName: updateData.apiName,
      parameters: parameters,
    };
    setUpdateRecordData((prevData) => ({
      ...prevData,
      [nodeId]: updateNode,
      data: {
        name: updateData.apiName,
        label: updateData.name
      }
    }));

    console.log(`updateData Records Data for node ${nodeId}:`, updateData);
  };

  const handleDeleteRecordSave = (nodeId, deleteData) => {

    console.log('node id::', nodeId);
    console.log('deleteData dataa::', deleteData);
    console.log('all nodes bfore upd:', nodes);
    const isDuplicate = Array.from(apiNameMap.entries()).some(
      ([id, name]) => id !== nodeId && name === deleteData.apiName
    );

    if (isDuplicate) {
      message.error('ApiName already used!');
      return;
    }


    setApiNameMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(nodeId, deleteData.apiName);
      return newMap;
    });

    console.log('apiNameMap updated:', apiNameMap);
    setDeleteNodeDrawer(false);

    // const allNodesData = getAllNodesData(getRecordsData, updateRecordData, deleteRecordData, createRecordData);

    // if (!isApiNameUnique(createData.apiName, nodeId, allNodesData)) {
    //   alert(`API name "${createData.apiName}" is already taken. Please choose a different name.`);
    //   return;
    // }

    // const parameters = getNodeParameters(createData, false); // Generate parameters for the node
    const parameters = deleteData.parameters; // Get parameters for the node
    // Update the nodes state
    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === nodeId
          ? {
            ...node,
            data: {
              ...node.data,
              nodeName: deleteData.apiName,
              label: deleteData.name
            },
            selectedObject: deleteData.selectedObject,
            parameters,
            description: deleteData.description,
            apiname: deleteData.apiName,
            name: deleteData.name,
          }
          : node
      )
    );

    console.log('all nodes::', nodes);
    // Prepare and save create record data separately
    const deleteNode = {
      id: deleteData.id,
      name: deleteData.name,
      type: deleteData.type,
      description: deleteData.description,
      apiName: deleteData.apiName,
      parameters: parameters,
    };

    setDeleteRecordData((prevData) => ({
      ...prevData,
      [nodeId]: deleteNode,
    }));

    console.log(`deleteData Records Data for node ${nodeId}:`, deleteData);
  };

  const handleDecisionRecordSave = (nodeId, decisionData) => {

    console.log('node id::', nodeId);
    console.log('decisionData dataa::', decisionData);
    console.log('all nodes bfore upd:', nodes);
    const isDuplicate = Array.from(apiNameMap.entries()).some(
      ([id, name]) => id !== nodeId && name === decisionData.apiName
    );

    if (isDuplicate) {
      message.error('ApiName already used!');
      return;
    }


    setApiNameMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(nodeId, decisionData.apiName);
      return newMap;
    });

    console.log('apiNameMap updated:', apiNameMap);
    setDeleteNodeDrawer(false);

    // const allNodesData = getAllNodesData(getRecordsData, updateRecordData, deleteRecordData, createRecordData);

    // if (!isApiNameUnique(createData.apiName, nodeId, allNodesData)) {
    //   alert(`API name "${createData.apiName}" is already taken. Please choose a different name.`);
    //   return;
    // }

    // const parameters = getNodeParameters(createData, false); // Generate parameters for the node
    const parameters = decisionData.parameters; // Get parameters for the node

    // Update the nodes state
    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === nodeId
          ? {
            ...node,
            data: {
              ...node.data,
              nodeName: decisionData.apiName,
              label: decisionData.name
            },
            selectedObject: decisionData.selectedObject,
            parameters,
            description: decisionData.description,
            apiname: decisionData.apiName,
            name: decisionData.name,
          }
          : node
      )
    );

    console.log('all nodes::', nodes);
    // Prepare and save create record data separately
    const decisionNode = {
      id: decisionData.id,
      name: decisionData.name,
      type: decisionData.type,
      description: decisionData.description,
      apiName: decisionData.apiName,
      parameters: parameters,
    };

    setDecisionNodeData((prevData) => ({
      ...prevData,
      [nodeId]: decisionNode,
    }));

    console.log(`decision Records Data for node ${nodeId}:`, decisionData);
  };


  const handleStartNodeSave = (startData) => {
    console.log('Start node dataa::', startData);
    setStartData(startData);
  }


  const generateFlowBody = (flowName, flowApiName, description, active) => {
    if (!startData?.object) {
      message.error("Please select object in the Start node.");
      return 'error'; // stop further execution
    }
    const modelName = startData?.object; // Adjust as needed
    const event = startData?.optimization === 'before_create' ? "before_create" : "after_create"; // Or "before insert", depending on requirement

    // Filter for insert nodes only (adjust as needed)
    // const filteredNodes = nodes.filter((node) => node.type === "insertNode");
    // Filter out start node
    const nonStartNodes = nodes.filter((node) => node.type !== "start");

    // 1. If no other nodes are added
    if (nonStartNodes.length === 0) {
      message.error("Please add at least one node to save the flow.");
      return 'error';
    }

    // 2. If any node is missing required data
    const incompleteNode = nonStartNodes.find((node) => {
      const params = node.parameters;
      console.log('paramsss::', params);
      console.log('node.name::', node.name);
      console.log('apiName::', node.apiname);
      return !params || !node.name;
    });

    if (incompleteNode) {
      message.error(`Please fill complete details in node: ${incompleteNode.data?.nodeName || incompleteNode.type}`);
      return 'error';
    }
    console.log('nodess::in gen body', nodes);
    const transformedNodes = nodes
      .filter((node) => node.type !== "start"
        // && node.id !== "end"
      ) // Exclude start and end nodes
      .map((node) => ({
        name: node.data?.nodeName || node.id, // Fallback to node.id
        label: node.data?.label,
        type: node.type,
        description: node.description,
        parameters: node.parameters || {
          model: node.parameters.model,
          fields: { Name: node.parameters.fields.name }, // Example placeholder, adjust as needed
        },
        coordinates: [node.position.x, node.position.y],
      }));

    console.log('Transformed Node', transformedNodes);

    const transformedTransitions = edges.map((edge) => {
      console.log('edgee:', edge);
      const fromNode = nodes.find((n) => n.id === edge.source);
      const toNode = nodes.find((n) => n.id === edge.target);

      return {
        from_node: fromNode?.data?.nodeName || edge.source,
        to_node: toNode?.data?.nodeName || edge.target,
        condition: "true", // You can add logic here if needed
      };
    });

    const flowBody = {
      name: flowApiName,
      label: flowName,
      model: modelName,
      event,
      description,
      active,
      mt_nodes: transformedNodes,
      mt_transitions: transformedTransitions,
    };

    return flowBody;
  };


  const handleNodeClick = (event, node) => {
    setHighlightedNode(node); // Update the current highlighted node ID
  };

  const removeApiNameForNode = (nodeId) => {
    setApiNameMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.delete(nodeId);
      return newMap;
    });
  }


  const handleBackspace = (event) => {

    if (event.code === 'Backspace' && highlightedNode) {
      if (highlightedNode.type === 'start') {
        // message.error('Cannot Delete the Start Node');
        return;
      }

      // Remove API name for the node from the set (searching all record data)
      removeApiNameForNode(highlightedNode.id);

      console.log('apiname set is ::', apiNameMap);

      // Delete the selected node from the nodes state
      setNodes((prevNodes) => prevNodes.filter((node) => node.id !== highlightedNode.id));

      // Remove the edges associated with the selected node
      setEdges((prevEdges) => prevEdges.filter((edge) => edge.source !== highlightedNode.id && edge.target !== highlightedNode.id));

      // Remove the associated data for the deleted node (in all the data states)
      setCreateRecordData((prevData) => {
        const { [highlightedNode.id]: _, ...remainingData } = prevData;
        return remainingData;
      });

      setGetRecordData((prevData) => {
        const { [highlightedNode.id]: _, ...remainingData } = prevData;
        return remainingData;
      });

      setUpdateRecordData((prevData) => {
        const { [highlightedNode.id]: _, ...remainingData } = prevData;
        return remainingData;
      });

      setDeleteRecordData((prevData) => {
        const { [highlightedNode.id]: _, ...remainingData } = prevData;
        return remainingData;
      })

      setCreateRecordData((prevData) => {
        const { [highlightedNode.id]: _, ...remainingData } = prevData;
        return remainingData;
      });

      // Clear the highlighted node after deletion
      setHighlightedNode(null);
    }
  };



  return (
    <>
      <TopUtilityBar selectedFlowData={selectedFlowData} generateFlowBody={generateFlowBody} object={object} isModalForFlowDetailsVisible={isModalForFlowDetailsVisible} setIsModalForFlowDetailsVisible={setIsModalForFlowDetailsVisible} name={formData?.name} formdata={formData} ></TopUtilityBar>
      <div style={{
        //  width: "100%",
        width: (assignmentNodeDrawer || showUpdateNodeDrawer || showGetNodeDrawer || startNodeDrawer || deleteNodeDrawer) ? "65%" : (createRecordDrawerVisible || decisionNodeDrawer) ? "55%" : "100%",
        height: 650,
        marginTop: 5,
        overflow: "hidden", // prevents internal scrollbars
        transition: "width 0.3s ease", // Smooth animation
        // overflow: "hidden",           // No scrollbars
        overflowY: "hidden",          // Ensures vertical scroll is disabled


      }}>
        <ReactFlowProvider>
          <ReactFlow
            nodes={enrichedNodes}
            // zoomOnPinch={false}  // disables two-finger zoom
            // zoomOnScroll={true}  // optional: allow scroll zoom
            // panOnScroll={true}   // optional: allow scroll panning          
            edges={styledEdges}
            onNodeClick={handleNodeClick}
            deleteKeyCode={null} // disables built-in deletion on Backspace/Delete
            onKeyDown={(e) => handleBackspace(e)}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onNodeDoubleClick={handleNodeDoubleClick}
            onConnect={(params) =>
              setEdges((eds) => [
                ...eds,
                {
                  ...params,
                  id: `e${params.source}-${params.target}`,
                  animated: true,
                  style: edgeStyleLight,
                },
              ])
            }
            nodeTypes={nodeTypes}
            onSelectionChange={onSelectionChange}
            fitView
            style={{ background: "#f9fafb", borderRadius: 8, border: "1px solid #ccc" }}
          >
            <MiniMap />
            <Controls />
            <Background color="#aaa" gap={16} />
          </ReactFlow>
        </ReactFlowProvider>
      </div>
      <CreateNodeFlowDrawer isEditingMode={false} selectedNode={selectedNode} onSave={handleCreateRecordSave} visible={createRecordDrawerVisible} onClose={() => setCreateRecordDrawerVisible(false)} nodeData={singleCreateRecordDataInEditMode} setNodeData={setNodeData} createRecordData={createRecordData} />
      <AssignmentNodeFlowDrawer isEditingMode={false} selectedNode={selectedNode} onSave={handleAssignmentRecordSave} visible={assignmentNodeDrawer} onClose={() => setAssignmentNodeDrawer(false)} nodeData={singleAssignmentRecordDataInEditMode} setNodeData={setNodeData} />
      <StartNodeDrawer startData={startData} nodeData={startData} onSave={handleStartNodeSave} openDrawer={startNodeDrawer} onClose={() => setStartNodeDrawer(false)}></StartNodeDrawer>
      <GetNodeFlowDrawer nodeData={singleGetRecordDataInEditMode} visible={showGetNodeDrawer} onSave={handleGetRecordSave} onClose={() => setShowGetNodeDrawer(false)} selectedNode={selectedNode}></GetNodeFlowDrawer>
      <UpdateNodeFlowDrawer nodeData={singleUpdateRecordDataInEditMode} visible={showUpdateNodeDrawer} onSave={handleUpdateRecordSave} onClose={() => setShowUpdateNodeDrawer(false)} selectedNode={selectedNode} setNodeData={setNodeData}></UpdateNodeFlowDrawer>
      {/* <DeleteNodeFlowDrawer nodeData={singleDeleteRecordDataInEditMode} visible={deleteNodeDrawer} onSave={handleDeleteRecordSave} onClose={() => setDeleteNodeDrawer(false)} selectedNode={selectedNode}></DeleteNodeFlowDrawer>
      <DecisionNodeFlowDrawer nodeData={singleDecisionRecordDataInEditMode} visible={decisionNodeDrawer} onSave={handleDecisionRecordSave} onClose={() => setDecisionNodeDrawer(false)} selectedNode={selectedNode}></DecisionNodeFlowDrawer> */}
    </>

  );
}


export default FlowScreen;
